module.exports = __webpack_public_path__ + "static/img/2.f27ca22.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-go/2.png
// module id = 7Kpf
// module chunks = 12